// ── 이 기기에서 로그인한 적이 있는지 기억 (2026-09-28, 미팅링크 소개 페이지) ──────────
//   첫 주소(/)에서 소개 페이지 대신 바로 로그인 화면으로 보낼지 HomeRedirect 가 본다.
//   로그인 성공(LoginPage)·로그인 토큰이 있는 채로 들어옴(PrivateRoute·HomeRedirect) 때 남기고,
//   로그아웃해도 지우지 않는다 — 로그아웃한 고객이 다음에 와도 소개 페이지 대신 로그인 화면을 보게.
//   저장이 막힌 브라우저(사생활 보호 모드 등)면 조용히 넘어간다 → 처음 온 사람처럼 동작.
const KEY = 'returning-visitor';

// 이 표시가 생기기 전(2026-09-28 이전)에 로그아웃해 둔 고객 기기 알아보기 —
//   로그인해야만 열리는 화면들이 남기는 저장값. 하나라도 있으면 로그인한 적 있는 기기다.
//   'pine-theme' 는 로그인 화면만 열어도 생기므로 넣지 않는다(처음 온 사람이 로그인 버튼만 눌러 봐도 생김).
const LOGGED_IN_TRACES = [
  'tenantMenuInfo.v1', // 사이드바 일일콜 메뉴 이름
  'companyScope.tenant', 'companyScope.company', 'companyScope.serverScope', // 작업 대상
  'meetingMap.lastSalesName', 'meeting-map-list-text-size', // 미팅지도
  'hidden-keep-ids', // 일일콜 킵 목록
];
const LOGGED_IN_TRACE_PREFIXES = ['mc_hidden_']; // 마케터 1:1 배정판

export function markReturningVisitor() {
  try { localStorage.setItem(KEY, '1'); } catch (_) { /* 저장 불가 — 무시 */ }
}

export function isReturningVisitor() {
  try {
    if (localStorage.getItem(KEY) === '1') return true;
    const hasTrace = LOGGED_IN_TRACES.some((k) => localStorage.getItem(k) !== null)
      || Object.keys(localStorage).some((k) => LOGGED_IN_TRACE_PREFIXES.some((p) => k.startsWith(p)));
    if (hasTrace) markReturningVisitor(); // 다음부터는 표시 하나로 바로
    return hasTrace;
  } catch (_) {
    return false;
  }
}
